import {
  DATA_BUS_SCOPES,
  publishScopedDataChange,
  resetScopedDataScope,
} from './opportunisticDataBus';
import { markTrendsV2ForHouseholdStale, purgeTrendsV2ForHousehold } from '../services/trendsV2CacheBridge';
import { invalidateDesktopTransactionSnapshots } from '../services/desktopTransactionSnapshots';

export const publishFinanceTrendDataChange = ({ householdId, background = false, monthKeys }) => {
  invalidateDesktopTransactionSnapshots(householdId, { monthKeys });
  if (background) markTrendsV2ForHouseholdStale(householdId, 'finance');
  else purgeTrendsV2ForHousehold(householdId, 'finance');
  publishScopedDataChange({
    scope: DATA_BUS_SCOPES.FINANCE_TRENDS,
    householdId,
  });
};

export const publishNetWorthTrendDataChange = ({ householdId }) => {
  purgeTrendsV2ForHousehold(householdId, 'networth');
  publishScopedDataChange({
    scope: DATA_BUS_SCOPES.NET_WORTH_TRENDS,
    householdId,
  });
};

export const resetFinanceTrendDataChanges = () => {
  resetScopedDataScope(DATA_BUS_SCOPES.FINANCE_TRENDS);
};

export const resetNetWorthTrendDataChanges = () => {
  resetScopedDataScope(DATA_BUS_SCOPES.NET_WORTH_TRENDS);
};
